import primeImg from "../../../assets/images/service/ev-management.jpeg";
import {
  Zap,
  ShieldCheck,
  LayoutDashboard,
  Cpu,
  RefreshCcw,
  Network,
  TrendingUp,
  Maximize,
  UserCheck,
  Activity,
  BarChart3,
  Clock
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function PrimeEVManagement() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    PRIME: <span className="green">Integrated Management</span> & Proactive Restoration
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise introduces the PRIME framework—a holistic ecosystem 
                    designed to manage, monitor, and restore EV charging networks 
                    using predictive analytics and integrated control systems.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Real-time integrated NOC (Network Operations Center) support</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Predictive restoration via AI-driven fault detection</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Unified management of HT/LT power & charger health</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={primeImg}
                      alt="PRIME Integrated Management"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-microchip"></i> Next-Gen Asset Management
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">The PRIME Ecosystem: Beyond Traditional AMC</h3>
                    <p className="mb-3">
                      Traditional maintenance reacts to failures; PRIME anticipates them. By integrating your charging station’s hardware with our centralized management layer, we oversee the entire energy chain—from the incoming 66kV/33kV utility feed to the final DC output at the vehicle connector. This integrated approach ensures that power quality issues are resolved before they can impact your charging hardware.
                    </p>
                    <p className="mb-3">
                      Our "Proactive Restoration" protocol means our technical team is often dispatched based on automated telemetry alerts, resolving software handshakes and load balancing issues remotely, or arriving on-site before a customer even reports a fault.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <LayoutDashboard size={22} />
                        </span>
                        <span>Centralized Dashboard for Multi-Location Monitoring</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Cpu size={22} />
                        </span>
                        <span>Smart Load Balancing & Grid Integration Management</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Network size={22} />
                        </span>
                        <span>End-to-End Handshake & Communication Restoration</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <BarChart3 size={22} />
                        </span>
                        <span>Revenue & Energy Analytics for Asset Optimization</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">Intelligence-Driven Reliability</h4>
                    <p className="mb-6">
                      PRIME transforms your EV infrastructure from a series of isolated machines into a resilient, self-healing network that maximizes user satisfaction and ROI.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <RefreshCcw size={22} />
                        </span>
                        <span>Automated self-healing for common software glitches</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Bank-grade security for CMS and payment data</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Enhanced asset life through optimized load cycling</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Clock size={22} />
                        </span>
                        <span>Zero-lag response via proactive alert triggers</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Scalable management for growing charging networks</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Strategic advisory for fleet-wide energy management</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}